/* eslint-disable import/prefer-default-export */
export const shouldAddMercately = (retailerInfo) => retailerInfo?.stripe_integrated
  || retailerInfo?.['payphone_connected?']
  || retailerInfo?.['mercado_pago_integrated?'];
